<template>
    <nav v-if="allocation.hasPaymentServices" class="payment-service-list">
        <VButton
            class="payment-service-btn rounded"
            v-for="service in allocation.paymentServices"
            :key="service.id"
            :class="{
                primary: isActivePaymentService(service),
                outlined: !isActivePaymentService(service),
                secondary: !isActivePaymentService(service),
            }"
            @click="setAsActivePaymentService(service)"
        >
            {{ translateByLocationLanguage(service.payUseCase?.name) }}
        </VButton>
    </nav>
</template>

<script setup lang="ts">
    import type { IService } from "@/data/model/Service";
    import { usePaymentStore } from "@/data/stores/payment";
    import { useTableAllocationStore } from "@/data/stores/tableAllocation";
    import { translateByLocationLanguage } from "@/shared/localization/language";

    import VButton from "@/components/elements/VButton.vue";

    const allocation = useTableAllocationStore();
    const payment = usePaymentStore();

    function isActivePaymentService(service: IService) {
        return payment.paymentService === service;
    }
    async function setAsActivePaymentService(service: IService) {
        await payment.setPaymentService(service);
    }
</script>

<style scoped lang="scss">
    .payment-service-list {
        white-space: nowrap;
        display: flex;
        align-items: center;
        padding: 0 1em;

        .payment-service-btn {
            margin: 0 2px;
            font-size: 16px;
            font-weight: 500;
        }
    }
</style>
